export default __webpack_public_path__ + "static/media/glow.3122bfba.pdf";